import React from 'react'
import { TypeFaceText } from './buttons.component'
import ImgIconComp from '../imgcomp'
import KrCluster from '../okr/kr-cluster/kr-cluster.component'
import GoalServices from './../../services/goal.services'
import { Button } from '@workboard/wobo-ui'
import { radioGroupHelper } from '../../utils/radio-helper';
import { eventKeyConstants } from '../../utils/eventKey';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import CKEDITOR from '@workboard/ckeditor5-build-wobo'
import EmojiContainer from '../emojis/emojis';
export class TextareaFieldComp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      enableNote:
        this.props.textareaProps && this.props.textareaProps.value != ''
          ? true
          : false,
      showCluster:
        this.props.textareaProps && this.props.textareaProps.value != ''
          ? true
          : false,
      clusterData: this.props.clusterData || [],
      localclusterData: [],
      ck_editor: null
    }
    this.enableNotArea = this.enableNotArea.bind(this)
    this.GoalServices = new GoalServices()
  }

  enableNotArea() {
    this.setState({ enableNote: !this.state.enableNote }, () => {
      const target = document.getElementById('metric-name-note');
      target && target.focus();
    })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.clusterData !== prevState.clusterData) {
      return { clusterData: nextProps.clusterData }
    } else return null
  }

  onBlurAddClusterItem = (e) => {
    const { item, goal_id, basicInlineDataName } = this.props
    if (
      e.target.value != '' &&
      item &&
      Object.keys(item).length &&
      e.target.value != item.name &&
      (basicInlineDataName ? e.target.value != basicInlineDataName : true)
    ) {
      if (this.props.displayKrClustering) {
        this.GoalServices.getClusterFireEvent({
          type: 'KR_CLUSTER_KR_NAME_CHANGED',
          source: item.id ? 'KR_EDIT' : 'KR_SIMPLE_CREATE',
        })
        this.GoalServices.getClusterData({
          goalId: item.goal_id || goal_id,
          metricId: item.id ? item.id : 0,
          text: e.target.value,
        }).then((response) => {
          if (response.status === 200) {
            this.props.updateClusterData(
              response.data.data.metrics[item.id || 0]['cKR']
            )
            if (item.id) {
              this.props.actions &&
                this.props.actions.updateClusterDataForIndividualItem({
                  resp: response.data.data,
                  item: item,
                })
            }
            if ($('.textarea-field-comp').find('.krCluster')) {
              $('.textarea-field-comp')
                .find('.krCluster')
                .addClass('ovalClicked')
              let clusterTimer = setInterval(() => {
                if (
                  $('.textarea-field-comp')
                    .find('.krCluster')
                    .hasClass('ovalClicked')
                )
                  $('.textarea-field-comp')
                    .find('.krCluster')
                    .removeClass('ovalClicked')
                else
                  $('.textarea-field-comp')
                    .find('.krCluster')
                    .addClass('ovalClicked')
              }, 300)
              setTimeout(() => {
                clearInterval(clusterTimer)
                if (
                  $('.textarea-field-comp')
                    .find('.krCluster')
                    .hasClass('ovalClicked')
                )
                  $('.textarea-field-comp')
                    .find('.krCluster')
                    .removeClass('ovalClicked')
              }, 3000)
            }
          }
        })
      }

      if (this.props.textareaProps.onBlur) {
        this.props.textareaProps.onBlur(e);
      }
    }
    this.setState({
      showCluster: e.target.value != '' ? true : false,
    })
  }

  setEditor = (editor) => {
    this.setState({
      ck_editor: editor
    });
  }

  render() {
    let {
      wrapperClass = '',
      label = '',
      labelClass = '',
      textareaProps = {},
      InputTypeFaceText = '',
      textAreaWrapper = '',
      distinguishedClass = '',
      distinguishedID = '',
      textareaRef = '',
      validationClass = '',
      validationText = '',
      width,
      notelabel,
      secondlabel = '',
      newLabelClass = '',
      displayKrClustering = false,
    } = this.props

    const { ck_editor } = this.state;
    return (
      <div
        className={'textarea-field-comp ' + wrapperClass}
        data-testid="textarea-field-comp"
      >
        <div className={width ? width : 'width100'}>
          {label && !notelabel ? (
            <div className={'label  ' + labelClass}>
              <label id="textarea-label">
                {label}
                {InputTypeFaceText.length > 0 ? <TypeFaceText /> : ''}
              </label>
            </div>
          ) : (
            ''
          )}
          {label && notelabel && !this.state.enableNote ? (
            <Button
              variant="ghost"
              onClick={this.enableNotArea}
              isDisabled={textareaProps.disabled}
              className="addDescriptionBtn">
              {label}
            </Button>
          ) : (
            <div className={'label  ' + newLabelClass}>
              <label>{secondlabel}</label>
            </div>
          )}
          {this.props.labelRightSide ? (
            <div
              className="label label-right right "
              dangerouslySetInnerHTML={{ __html: this.props.labelRightSide }}
            />
          ) : (
            ''
          )}
          <div className="jiraQueryValidation" aria-hidden={!(validationText && validationText.length > 0)}>
            {validationClass && validationClass === 'jiraQueryValidation' && (
              <ImgIconComp
                id="loadinggif"
                width="20"
                height="20"
                class="jiraValidationRotating"
              />
            )}
            {validationText && validationText.length > 0 && (
              <div className="inLineBlk">
                {validationClass.length == 0 && (
                  <span className="validationCheckedJira"></span>
                )}
                <span className="validationTextJira">{validationText}</span>
              </div>
            )}
          </div>
        </div>
        {notelabel && this.state.enableNote ? (
          <div
            className={`${width ? width : 'width100'} ${distinguishedClass}`}
          >
            <CKEditor
              editor={CKEDITOR.ClassicEditor}
              id={textareaProps.id}
              name={textareaProps.name}
              data={textareaProps.value}
              disabled={textareaProps.disabled}
              config={{
                licenseKey: window.ckeditorLicenseKey,
                toolbar: {
                  items: ['bold', 'italic', 'link', 'undo', 'numberedList', 'bulletedList', 'strikethrough', 'underline', 'horizontalLine']
                }
              }}
              onChange={(e, editor) => {
                const data = editor.getData();
                textareaProps.onChange(e, data);
              }}
              onReady={editor => {
                this.setEditor(editor);
              }}

            // {...textareaProps}
            // onBlur={event => this.handleGoalNarrativeChange(event)}
            />
            {/* <textarea
              ref={textareaRef}
              id={distinguishedID}
              className={textAreaWrapper + ` ${distinguishedClass}`}
              {...textareaProps}
            ></textarea> */}
            <EmojiContainer
              ck_editor={ck_editor}
              editorId={textareaProps.id}
            />
          </div>
        ) : (
          ''
        )}
        {!notelabel && (
          <div
            className={`${width ? width : 'width100'} ${distinguishedClass}`}
            style={displayKrClustering ? { display: 'flex' } : {}}
          >
            <textarea
              ref={textareaRef}
              id={distinguishedID}
              className={textAreaWrapper + ` ${distinguishedClass}`}
              {...textareaProps}
              onBlur={this.onBlurAddClusterItem}
              aria-labelledby="textarea-label"
              aria-invalid="false"
            ></textarea>
            {displayKrClustering &&
              this.state.showCluster &&
              this.state.clusterData &&
              this.state.clusterData.length > 0 && (
                <KrCluster
                  popupClass="clusterRight"
                  updateKRStates={this.props.updateKRStates}
                  metric={this.props.item}
                  actions={this.props.actions}
                  onlyMetEdit={this.props.onlyMetEdit}
                  clusterCount={
                    this.state.localclusterData.length ||
                    this.state.clusterData.length
                  }
                  clusterData={
                    this.state.localclusterData.length
                      ? this.state.localclusterData
                      : this.state.clusterData
                  }
                  isChildKr={this.props.isChildKr}
                  childKrDuration={this.props.childKrDuration}
                  saveNestedKRs={this.props.saveNestedKRs}
                  goal_id={this.props.goal_id}
                  nestedKrIndex={this.props.nestedKrIndex}
                  fromParentKr={this.props.fromParentKr}
                  closeKrRightPanel={this.props.closeKrRightPanel}
                  display_nested_kr={this.props.display_nested_kr}
                  nested_krs={this.props.nested_krs}
                />
              )}
          </div>
        )}
        <div id="krNameError" className="krNameError" aria-hidden="true"></div>
      </div>
    )
  }
}

export const CheckBoxComp = (props) => {
  let {
    id = '',
    label = '',
    onChange = '',
    classDefined = '',
    subclassDefined = '',
    checkboxProps = {},
    labelStyle = {},
    labelClass = '',
    role = '',
  } = props
  if (onChange) {
    if (props.item) {
      checkboxProps.onChange = (e) => onChange(e, props.item)
    } else {
      checkboxProps.onChange = (e) => onChange(e)
    }
  }
  //let labelcss = 'react-check-label';
  let labelcss =
    'icon icon-outline-check_box_outline_blank-24px labelPositionSetCheck'
  if (labelClass) {
    labelcss += ' ' + labelClass
  }

  const handleChange = (e) => {
    e.preventDefault();
    onChange(
      {
        target: {
          checked: !checkboxProps.checked,
        },
      },
      props.item ? props.item : undefined
    )
  }

  return (
    <div className={'inLineBlk ' + subclassDefined}>
      <input
        type="checkbox"
        id={id}
        {...checkboxProps}
      // role={role}
      />
      <span
        aria-checked={checkboxProps.checked}
        aria-labelledby={`span_${id}`}
        className="react-check"
        checked={checkboxProps.checked}
        role="checkbox"
        tabIndex={0}
        onClick={handleChange}
        onKeyDown={(e) => {
          if (e.key === ' ') {
            handleChange(e)
          }
        }}
      />
      <label htmlFor={id} className={labelcss} style={labelStyle}></label>
      {props.icons ? <span className={props.icons}></span> : ''}
      {label ? (
        <span id={'span_' + id} className={classDefined}>
          {label}
        </span>
      ) : (
        ''
      )}
    </div>
  )
}

export const RadioButComp = (props) => {
  let {
    id = '',
    label = '',
    classDefined = '',
    subclassDefined = '',
    onClick = '',
    radioButProps = {},
    forWSImport = false,
    htmlForString = '',
    selectedClass = false,
  } = props
  if (forWSImport) {
    return (
      <div className="select-project-tab">
        <input
          type="radio"
          className="react-radio"
          id={id}
          {...radioButProps}
        />
        {radioButProps && radioButProps.defaultChecked ? (
          <div className="seleced-radio radioAllCommonFix"></div>
        ) : (
          <div
            className="empty-radio radioAllCommonFix"
            onClick={(e) => onClick(e)}
            data-value={radioButProps && radioButProps.value}
          ></div>
        )}
        <label
          className="react-radio-label radioAllCommonDescFix project-name truncateText"
          htmlFor={id}
        >
          {label}
        </label>
        {/* <div  className="project-name truncateText">
                <div className="project-name-div" title={item[projectType+"_name"]}>{item[projectType+"_name"]}</div>
            </div> */}
      </div>
    )
  } else {
    return (
      <div className={'inLineBlk ' + subclassDefined}>
        <input type="radio" className="react-radio" {...radioButProps} />
        {radioButProps && radioButProps.defaultChecked ? (
          <div
            className={`${selectedClass ? 'selectedRadio' : ''
              } seleced-radio radioAllCommonFix`}
          ></div>
        ) : (
          <div
            className="empty-radio radioAllCommonFix"
            id={id}
            onClick={(e) => onClick(e)}
          ></div>
        )}
        <label htmlFor={id} className="react-radio-label radioAllCommonDescFix">
          {label}
        </label>
      </div>
    )
  }
}

export const ErrorTextComp = (props) => {
  let { errors = {}, field = '', errorClass = '' } = props
  return typeof errors[field] !== 'undefined' ? (
    <div
      className={'error-text ' + errorClass}
      role="alert"
      aria-label={errors[field]}
      aria-atomic="true"
      aria-live='polite'
    >
      
      { errors[field] == 'highlightOnly' ? "" : <span className="icon icon-outline-error_outline-14px-red"></span>}
      { errors[field] == 'highlightOnly' ? "" : (
      <span className="error-text-msg" aria-hidden="true">
        {errors[field]}
      </span>)} 
     
    </div>
  ) : null
}
export const AlertErrorTextComp = (props) => {
  let { errors = {}, field = '', errorClass = '', id='' } = props
  return typeof errors[field] !== 'undefined' ? (
    <div
      className={'error-text ' + errorClass}
    >
      <span className="icon icon-outline-error_outline-14px-red"></span>
      <span className="error-text-msg" aria-hidden="true" id={id}>
        {errors[field]}
      </span>
    </div>
  ) : null
}
export const RadioGroupButtons = (props) => {
  const radioGroupID = 'survey-radio-btn-group-aE-create-ws';
  let { items = [], defaultValue = '' } = props

  const onKeyhandler = (e, index) => {
    if (e.key === eventKeyConstants.ARROWUP || e.key === eventKeyConstants.ARROWLEFT) {
      e.preventDefault();
      if (index === 0) {
        props.onChange(items[items.length - 1])
      } else {
        props.onChange(items[index - 1])
      }
    } else if (e.key === eventKeyConstants.ARROWDOWN || e.key === eventKeyConstants.ARROWRIGHT) {
      e.preventDefault();
      if (index === items.length - 1) {
        props.onChange(items[0])
      } else {
        props.onChange(items[index + 1])
      }
    }
  }

  if (items.length) {
    return (
      <div className="radiogroupbuttons-wrapper">
        {items.map((item, index) => (
          <div
            key={props.name + '_' + item.id}
            className="radio-button-comp"
            onClick={() => props.onChange(item)}
            onKeyDown={(e) => radioGroupHelper(radioGroupID,
              () => onKeyhandler(e, index), e)}
          >
            <span>
              <span
                className={
                  'icon ' +
                  (item.value == defaultValue
                    ? 'icon-outline-radio_button_checked-24px'
                    : 'icon-outline-radio_button_unchecked-24px')
                }
                tabIndex={item.value == defaultValue ? 0 : -1}
                role="radio"
                aria-checked={item.value == defaultValue}
                aria-labelledby={`input-radio-${item.id}`}
              ></span>
              <input
                type="radio"
                name={props.name}
                value={item.value}
                readOnly
              />
            </span>
            <span
              className="radio-button-label"
              id={`input-radio-${item.id}`}
            >
              {item.label}
            </span>
          </div>
        ))}
      </div>
    )
  } else {
    return null
  }
}

export default {
  TextareaFieldComp,
  CheckBoxComp,
  RadioButComp,
  ErrorTextComp,
  RadioGroupButtons,
}
